import { inject as service } from '@ember/service';
import { oneWay } from '@ember/object/computed';
import Route from 'cio/routes/base';
import { singularize } from 'ember-inflector';

export default class ItemRoute extends Route {
  @service store;

  crumb() {
    return {
      name: oneWay('model.id'),
      path: 'data-index.type.item.index',
      model: this.modelFor(this.routeName),
    };
  }

  model(params) {
    let parentParams = this.paramsFor('data-index.type');
    let type = singularize(parentParams.type);

    return this.store.findRecord(type, params.item_id);
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.fetchLogs.perform();
  }
}
